import { useRouteError } from "react-router";
import { getErrorMessage } from "@/lib/error-utils";

export default function ErrorPage() {
	const error = useRouteError();

	return (
		<div className="min-h-screen flex items-center justify-center p-4">
			<div className="text-center space-y-2">
				<h1 className="text-2xl font-semibold tracking-tight">Oops</h1>
				<p className="text-sm">Sorry, an unexpected error has occurred.</p>
				<p className="text-xs text-muted-foreground">
					{getErrorMessage(error)}
				</p>
			</div>
		</div>
	);
}
